import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknownFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			fill: "currentColor",
			children: [/* @__PURE__ */ _jsx("path", { d: "M24.706 7.022 17.98.294A1.005 1.005 0 0 0 17.271 0H4c-.553 0-1 .447-1 1v26c0 .553.447 1 1 1h20c.553 0 1-.447 1-1V7.728a.998.998 0 0 0-.293-.706Zm-2.013 1.165h-5.881v-5.88l5.881 5.88Zm.056 17.563H5.25V2.25h9.438V9a1.312 1.312 0 0 0 1.312 1.313h6.75V25.75Z" }), /* @__PURE__ */ _jsx("path", { d: "M3 .072 1.339 1.577l23.98 26.465 1.662-1.505z" })]
		}),
		"Ï"
	]
});
const ForwardRef = forwardRef(SvgUnknownFile);
export { ForwardRef as ReactComponent };
